import React from 'react';
import "./styles.css";
/**
 * @function UIButton 
 * @param {FUNCTION} onClick - Pass an onClick event in the component.
 * @param {React.Component} children - React components that's being wrapped by the UIButton component.
 * @returns {React.Component}
 * @example
 *  <UIButton className="primary-button" onClick={() => this.handleClick()}>Button Name</UIButton>
 */
export default function UIButton(props) {
  const { dataPoint, ...resProps } = props;
  const dataPointProp = { "data-point": dataPoint ?? undefined };
  return (
    <button { ...resProps } { ...dataPointProp } onClick={props.onClick}>
      <span>{props.children}</span>
    </button>
  )
}